import React from 'react'
import '../index.scss'

const DisabledTable = () => (
    <div className="royalties-table">
        <table>
            <tbody>
                <tr>
                    <th className="index-white">Payee</th>
                    <th className="index-white">DSP</th>
                    <th className="index-white">Distribution Period</th>
                    <th className="index-white">Use Type</th>
                    <th className="index-white">Amount</th>
                    <th className="index-white">Select</th>
                </tr>
            </tbody>
        </table>
    </div>
)

export default DisabledTable
